import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectIsAuth } from "../../redux/slices/auth";
import styles from "./Header.module.scss";

import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";

export const Header = () => {
  const dispatch = useDispatch();
  const isAuth = useSelector(selectIsAuth);

  const onClickLogout = () => {
    if (window.confirm("Вы уверены что хотите выйти?")) {
      dispatch(logout());
      window.localStorage.removeItem("token");
    }
  };

  return (
    <div className={styles.root}>
      <Container maxWidth="lg">
        <div className={styles.inner}>
          <Link className={styles.logo} to="/">
            <div>ГРИНДЕР У МАЙСТЕРНЮ. БЛОГ</div>
          </Link>

          <div className={styles.contact}>
            <p className={styles.contactLine}>
              Попов Дмитро, м. Київ,
              <span className={styles.iconsContainer}>
                <PhoneIcon className={`${styles.icon} ${styles.phone}`} />
                <WhatsAppIcon className={`${styles.icon} ${styles.viber}`} />
                <TelegramIcon className={`${styles.icon} ${styles.telegram}`} />
                <WhatsAppIcon className={`${styles.icon} ${styles.whatsapp}`} />
              </span>
              +38(050)328-29-60
            </p>
            <p className={styles.contactLine}>
              <span>
                <EmailIcon className={`${styles.icon} ${styles.email}`} />
              </span>
              popov.dimitriy@gmail.com
            </p>
          </div>

          <div className={styles.buttons}>
            <Link to="/prices">
              <Button className={styles.price}
                variant="contained"
                color="success"
                style={{ marginLeft: 10 }}
              >
                Ціни
              </Button>
            </Link>

            {isAuth ? (
              <>
                <Link to="/add-post">
                  <Button variant="contained">Написати статтю</Button>
                </Link>
                <Link to="/profile">
                  <Button variant="contained" color="secondary">
                    Профіль
                  </Button>
                </Link>
                <Button
                  onClick={onClickLogout}
                  variant="contained"
                  color="error"
                >
                  Вийти
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outlined">Увійти</Button>
                </Link>
                <Link to="/register">
                  <Button variant="contained">Створити аккаунт</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
